import { createStyles, IconButton, ListItem, ListItemSecondaryAction, ListItemText, makeStyles, Menu, MenuItem, Paper } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import React from 'react';

const useStyles = makeStyles((theme) =>
    createStyles({
        item: {
            flex: 1,
            width: '100%',
            color: '#fff',
            backgroundColor: '#191D24',
            marginBottom: theme.spacing(0.5),
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            [theme.breakpoints.down('sm')]: {
                paddingTop: 0,
                paddingBottom: 0,
            },
            [theme.breakpoints.up('md')]: {
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
            },
        },
    }),
);

interface Props {
    entry: any
    onDetailsClick: (entry: any) => void
    onDeleteClick: (entry: any) => void
}

const ITEM_HEIGHT = 48;

export default function EntryItem({
    entry,
    onDetailsClick,
    onDeleteClick
}: Props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const options = [
        {
            label: "Details",
            onClick: onDetailsClick
        },
        {
            label: "Delete",
            onClick: onDeleteClick
        },
    ];

    return (
        <React.Fragment>
            <Paper variant="elevation" className={classes.item} color="#0C1017">
                <ListItem button onClick={() => onDetailsClick(entry)}>
                    <ListItemText
                        primary={entry?.poc ? entry?.name : `${entry?.firstName} ${entry?.lastName}`}
                    />
                    <ListItemSecondaryAction>
                        <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleClick}
                        >
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={open}
                            onClose={handleClose}
                            PaperProps={{
                                style: {
                                    maxHeight: ITEM_HEIGHT * 4.5,
                                    width: '20ch',
                                },
                            }}
                        >
                            {options.map((option, index) => (
                                <MenuItem key={index} onClick={() => {
                                    option.onClick(entry);
                                    handleClose();
                                }}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Menu>
                    </ListItemSecondaryAction>
                </ListItem>
            </Paper>
        </React.Fragment>
    )
}
